import React from 'react'
import { useState,useEffect } from 'react'
import ApiUrl from '../../../configTools/apiUrl'


import Title from '../../../components/forms/title'
import New from '../../../components/forms/new'
import Item from './item'
import Searchbar from '../../../components/forms/searchbar'

const Category = () => {
  const [Categories,setCategories] = useState([]);
  const get_admin_nav = () =>{
    fetch(ApiUrl.API_URL_Collection)
    .then(res=>res.json())
    .then(data =>{
      setCategories(data);
      setFilterCategories(data)
    });
  }
  const [FilterCategories,setFilterCategories] = useState(Categories);
  function filterFunction(value){
    if(value === ""){
        setFilterCategories(Categories);
    }
    else{
      const filtedCategories = Categories.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilterCategories(filtedCategories);
    }
  }
  useEffect(() => {
    get_admin_nav();
  },[])
  return (
    <div className='form_container'>
      <Title Name='Category' BackURL = {null}/>
      <New to='add'/>
      <div className='form_table_container'>
        <Searchbar Filter={filterFunction}/>
        <div className='form_item_row_container title'>
          <div className='form_item_row_container_itemfull' style={{width:'25%'}}>
            <p>Title</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'20%'}}>
            <p>Type</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'20%'}}>
            <p>Slug</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'25%'}}>
            <p>Discription</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'20%'}}>
            <p>Parent</p>
          </div>
        </div>
        {
          FilterCategories.map((item)=>{
            return(
              <Item Obj = {item} key={item.id} />
            );
          })
        }
      </div>
    </div>
  )
}

export default Category
